export default __webpack_public_path__ + "static/media/course_img_ii.b213d4d9.jpg";